var _path, _path2;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconCreditCardVisa(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4 6.25h24c.966 0 1.75.784 1.75 1.75v16A1.75 1.75 0 0128 25.75H4A1.75 1.75 0 012.25 24V8c0-.966.784-1.75 1.75-1.75z",
    fill: "#fff",
    stroke: "#D1D1D1",
    strokeWidth: 0.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.366 12.642l-2.884 6.87H8.595l-1.423-5.481c-.072-.32-.178-.463-.428-.605A7.167 7.167 0 005 12.856l.036-.214H8.06c.392 0 .748.25.82.712l.747 3.987 1.851-4.663h1.887v-.036zm7.333 4.593c0-1.816-2.492-1.923-2.492-2.706 0-.25.25-.498.748-.57.249-.035.96-.07 1.744.32l.32-1.459c-.427-.142-.96-.32-1.673-.32-1.744 0-2.99.926-2.99 2.278 0 .997.89 1.531 1.566 1.851.677.32.926.534.926.855 0 .463-.534.676-1.068.676-.89 0-1.424-.249-1.816-.427l-.32 1.495c.427.178 1.175.356 1.958.356 1.887 0 3.097-.925 3.097-2.35zm4.663 2.242H27l-1.424-6.87h-1.53a.787.787 0 00-.748.498l-2.67 6.372h1.851l.356-1.032h2.278l.25 1.032zm-1.993-2.42l.925-2.563.534 2.563h-1.46zm-7.476-4.415l-1.46 6.87h-1.78l1.46-6.87h1.78z",
    fill: "#1A1F71"
  })));
}

export default SvgIconCreditCardVisa;